import React, { useState } from "react";
import styles from "./MammalChampion.module.scss";
import JoinComponent from "./JoinComponent";
import { Link } from "@reach/router";
import Username from "./Username";

function PlantChampion(props) {
  const [plantNo, setPlantNo] = React.useState(0);

  if (plantNo === 0) {
    return (
      <div className={styles.bkg}>
        <p>
          You hear voices in your daily walk, you look down, and see the most
          beautiful flower talking to you.
        </p>
        <p>
          "Once upon a time there was a tulip bulb. It had a red flower with
          flashes of white colouring. It was the most beautiful tulip flower
          ever. Of course, I'm talking about myself, who else?
        </p>
        <p>
          We are the Champion of the Plant Folk, the Tulips! We are many, and we
          are in need of help... Would you listen to what we have to say?"
        </p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(1);
          }}
        >
          Keep listening
        </button>{" "}
        <br />
        <JoinComponent folk={props.type} alpha={props.alpha} />
      </div>
    );
  }
  if (plantNo === 1) {
    return (
      <div className={styles.bkg}>
        <p>
          "You can learn a lot about the Plant Folk just by hanging around here,
          Abercromby Square they call it. Or maybe you would like to go and meet
          Sister Tulip in Mossley Hill. Or maybe you would like to meet Brother
          Tulip in Wavertree Garden Suburb... where would you like to go?
        </p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(2);
          }}
        >
          Abercromby Square
        </button>{" "}
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(8);
          }}
        >
          Mossley Hill
        </button>{" "}
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(11);
          }}
        >
          Wavertree Garden Suburb
        </button>{" "}
      </div>
    );
  }

  if (plantNo === 2) {
    return (
      <div className={styles.bkg}>
        <p>
          "Abercromby Square is where I live peacefully in a flowerbed. In the
          morning{" "}
        </p>{" "}
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(5);
          }}
        >
          the sun comes up
        </button>{" "}
        <p>and I open my flower.</p> <p>In the evening </p>{" "}
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(3);
          }}
        >
          the sun goes down{" "}
        </button>
        <p>and my flower closes.</p>
        <p>Seems like a simple life we live, but every plant is different.</p>
        <p>
          Help me find other plants in the map. They can explain to you how to
          make points and help the Plant Folk win.
        </p>
        <p>Help us unite our voices."</p>
      </div>
    );
  }
  if (plantNo === 3) {
    return (
      <div className={styles.bkg}>
        <p>
          The sun sinks in the{" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setPlantNo(4);
            }}
          >
            west
          </button>
        </p>
      </div>
    );
  }
  if (plantNo === 4) {
    return (
      <div className={styles.bkg}>
        <p>"I have spent all day in Abercromby Square.</p>

        <p> I am ready to sleep and prepare for another day."</p>

        <p> Join the Plant Folk if you're ready to sleep as well.</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(12);
          }}
        >
          Join the Plant Folk
        </button>
      </div>
    );
  }
  if (plantNo === 5) {
    return (
      <div className={styles.bkg}>
        <p>
          "I sway in the sunshine. My flower follows the passage of the sun from{" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setPlantNo(6);
            }}
          >
            East."{" "}
          </button>
        </p>
      </div>
    );
  }
  if (plantNo === 6) {
    return (
      <div className={styles.bkg}>
        <p>"The sun comes up and humans come into Abercromby Square.</p>
        <p>They look at me and love me. Of course.</p>
        <p> One of the humans</p>{" "}
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(7);
          }}
        >
          picks my flower,
        </button>{" "}
        <p>
          I am horrified. Half of me is being stolen. I am nothing without my
          flower. It is spring and this is my only chance this year to bloom.
        </p>
        <p>I need my flower."</p>
      </div>
    );
  }
  if (plantNo === 7) {
    return (
      <div className={styles.bkg}>
        <p> "My flower is taken far away and I never see it again.</p>

        <p>Please join the Plant Folk and help us.</p>

        <p>
          Help us regain our lost voice by placing Incident Markers on the map,
          that way, we will be heard again."
        </p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(12);
          }}
        >
          Join the Plant Folk
        </button>
      </div>
    );
  }
  if (plantNo === 8) {
    return (
      <div className={styles.bkg}>
        <p>"I am Sister Tulip.</p>

        <p>I live in a flowerpot in a small backyard.</p>

        <p>
          I live here with daffodil
          <button
            className={styles.choice}
            onClick={(event) => {
              setPlantNo(9);
            }}
          >
            daffodil
          </button>{" "}
          and a{" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setPlantNo(10);
            }}
          >
            cat
          </button>
          .
        </p>
      </div>
    );
  }
  if (plantNo === 9) {
    return (
      <div className={styles.bkg}>
        <p>
          "The Daffodil is bright yellow and tries very hard to be more
          beautiful than me.
        </p>
        <p>But I am happy to sit quietly and be beautiful."</p>
        <p>If you feel like being quiet and beautiful...</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(12);
          }}
        >
          Join the plant folk
        </button>{" "}
      </div>
    );
  }
  if (plantNo === 10) {
    return (
      <div className={styles.bkg}>
        <p>
          "The cat likes to sit in the sun.
          <br />
          It sits on me.
          <br />
          And squashes me."
        </p>
        <p>
          The Other Folks are not being very respectful. Help the Plant Folk by
          placing Incident Reports about problems you detect in your area, daily
          walks or favourite parks.
        </p>
        <p>Only one Folk can win!</p>
        <p>Find and talk to other plants to learn more!</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(12);
          }}
        >
          Join the plant folk
        </button>{" "}
      </div>
    );
  }
  if (plantNo === 11) {
    return (
      <div className={styles.bkg}>
        <p>"I am Brother Tulip, from the Plant Folk.</p>
        <p>Sometimes the Pansies are a bit unkind to me.</p>
        <p>
          They flower for such a long time and they think I am a lightweight
          because I don't flower for very long.
        </p>
        <p>Do you think I am a lightweight?"</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(12);
          }}
        >
          Yes
        </button>{" "}
        or{" "}
        <button
          className={styles.choice}
          onClick={(event) => {
            setPlantNo(12);
          }}
        >
          No
        </button>
      </div>
    );
  }

  if (plantNo === 12) {
    return (
      <div className={styles.bkg}>
        <p> "Please join the Plant Folk and help the tulips.</p>

        <p>
          {" "}
          We really need to be known by our strength rather than just our
          beauty.
        </p>

        <p>
          {" "}
          Help us regain our lost voice by placing Incident Markers on the map,
          that way, we will be heard again."
        </p>

        <Link className={styles.choice} to={"/" + props.type + ""}>
          Enter as one of the Plant Folk
        </Link>
      </div>
    );
  }
}
export default PlantChampion;
